// extracted by mini-css-extract-plugin
module.exports = {"sidebarCollapse":"576px","contextedBlue":"#1e4bc4","gray400":"#ced4da","gray600":"#6c757d","gray700":"#495057","gray800":"#343a40"};